import React, { createContext, useCallback, useState, useContext } from 'react'
import { ParameterContext } from '../../wrappers/ParameterContext'

const AppStateContext = createContext(null)

const AppStateContextProvider = ({ children }) => {
    const { params, setParams } = useContext(ParameterContext)
    const [promotedRecords, setPromotedRecords] = useState(false)
    const [detailState, setDetailState] = useState({
        well: {
            visible: false,
            facilityID: null,
        }
    })

    const [filterState, setFilterState] = useState({
        well: false,
        sample: false
    })

    const [mapState, setMapState] = useState({
        selectedFeatures: [],
        allFeatures: [],
        map: null
    })

    const updateDetailState = (name, newState) => {
        const newDetailState = {
            [name]: {
                ...detailState[name],
                ...newState,
            },
        }
        setDetailState({
            ...detailState,
            ...newDetailState,
        })
    }

    const updateFilterState = (name, newState) => {
        setFilterState({
            ...filterState,
            [name]: newState
        })
    }

    const syncFilterState = newState => {
        const newFilters = Object.keys(filterState).map(filter => ({[filter]: newState}))
        setFilterState(newFilters)
    }

    const togglePromotedRecords = useCallback((promoted) => {
        const newParams = {
            ...params.app,
            Promoted: promoted
        }
        setPromotedRecords(promoted)
        setParams(newParams, 'app')
    }, [params])

    return (
        <AppStateContext.Provider
            value={{
                detailState,
                updateDetailState,
                mapState,
                setMapState,
                filterState,
                updateFilterState,
                syncFilterState,
                promotedRecords, 
                togglePromotedRecords
            }}
        >
            {children}
        </AppStateContext.Provider>
    )
}

export { AppStateContext }
export default AppStateContextProvider
